import React, { useEffect, useState } from 'react'
import { Alert, Button, Drawer, Form, Input, message, notification, Popconfirm } from 'antd'
import {
    PlusOutlined,
    SaveOutlined,
    EditOutlined,
    DeleteOutlined,
} from '@ant-design/icons';
import Container from '../../../components/Container'
import Main from '../../../components/Main'
import PageHeader from '../../../components/PageHeader'
import AgoraTable from '../../../components/Table';
import { useAuthUser } from 'react-auth-kit';
import axios from 'axios';

function NameTitle() {
    const auth = useAuthUser()
    const [nameTitleForm] = Form.useForm();
    const [state, setState] = useState({
        gvNameTitleLoading: false,
        gvNameTitle: [],
        formOpen: false,
        formType: "Add",
        btnSubmitLoading: false,
        btnSubmitResStatus: "",
        btnSubmitResMsg: "",
        btnDeleteLoading: false,
    })
    const handleSetState = (newState) => {
        setState(prevState => ({
            ...prevState,
            ...newState,
        }))
    }
    useEffect(() => {
        getNameTitlePageLoad()
        // eslint-disable-next-line
    }, [])
    const getNameTitlePageLoad = () => {
        handleSetState({ gvNameTitleLoading: true })
        axios.get(`/NameTitle/PageLoad`).then(res => {
            let resData = res.data
            if (resData.Status === "True") {
                handleSetState({
                    gvNameTitleLoading: false,
                    gvNameTitle: resData.Data.gvNameTitle
                })
                return resData.Data
            } else {
                message.error(resData.Message)
            }
        }).catch(error => {
            console.log(error)
            message.error(error.message)
        })
    }
    const handleOnFinishNameTitle = (formData) => {
        handleSetState({ btnSubmitLoading: true })
        if (state.formType === "Add") {
            axios.post(`/NameTitle/Create`, {
                nameTitleDesc: formData.nameTitleDesc,
                createdBy: auth().userId,
            }).then(res => {
                let resData = res.data
                if (resData.Status === "True") {
                    handleSetState({
                        formOpen: false,
                        btnSubmitLoading: false
                    });
                    getNameTitlePageLoad();
                    notification.success({
                        message: "Successful",
                        description: resData.Message
                    });
                } else {
                    handleSetState({
                        btnSubmitLoading: false,
                        btnSubmitResStatus: resData.Status,
                        btnSubmitResMsg: resData.Message,
                    });
                }
            }).catch(error => {
                console.log(error);
                message.error(error.message);
            })
        } else if (state.formType === "Edit") {
            axios.post(`/NameTitle/Update`, {
                nameTitleId: formData.nameTitleId,
                nameTitleDesc: formData.nameTitleDesc,
                modifiedBy: auth().userId,
            }).then(res => {
                let resData = res.data
                if (resData.Status === "True") {
                    handleSetState({
                        formOpen: false,
                        btnSubmitLoading: false
                    });
                    getNameTitlePageLoad();
                    notification.success({
                        message: "Successful",
                        description: resData.Message
                    });
                } else {
                    handleSetState({
                        btnSubmitLoading: false,
                        btnSubmitResStatus: resData.Status,
                        btnSubmitResMsg: resData.Message,
                    });
                }
            }).catch(error => {
                console.log(error);
                message.error(error.message);
            })
        }

    }
    const handleOnDeleteNameTitle = () => {
        handleSetState({ btnDeleteLoading: true })
        axios.post(`/NameTitle/Delete`, {
            nameTitleId: nameTitleForm.getFieldValue("nameTitleId"),
            modifiedBy: auth().userId,
        }).then(res => {
            let resData = res.data
            if (resData.Status === "True") {
                handleSetState({
                    formOpen: false,
                    btnDeleteLoading: false
                });
                getNameTitlePageLoad();
                notification.success({
                    message: "Successful",
                    description: resData.Message
                });
            } else {
                handleSetState({
                    btnDeleteLoading: false,
                    btnSubmitResStatus: resData.Status,
                    btnSubmitResMsg: resData.Message,
                });
            }
        }).catch(error => {
            console.log(error);
            message.error(error.message);
        })

    }

    const isAllowToManage = () => {
        if (auth().role === "Admin") {
            return true
        }
        return false;
    }

    return (
        <Main listBreadcrumb={[
            { key: "1", title: "Maintenance" },
            { key: "2", title: "Library" },
            { key: "3", title: "Name Title" },
        ]}>
            <Container>
                <PageHeader title="Name Title" subtitle="List of name title details.">
                    {isAllowToManage() &&
                        <Button
                            type="primary"
                            icon={<PlusOutlined />}
                            onClick={() => {
                                nameTitleForm.resetFields()
                                handleSetState({
                                    formOpen: true,
                                    formType: "Add",
                                })
                            }}
                        >
                            New Name Title
                        </Button>
                    }
                </PageHeader>
                <AgoraTable
                    loading={state.gvNameTitleLoading}
                    dataSource={state.gvNameTitle}
                    rowKey="nameTitleId"
                    columns={[
                        {
                            title: 'Name Title',
                            dataIndex: 'nameTitleDesc',
                            key: 'nameTitleDesc',
                            dataType: "text",
                            render: (text, record) => <div className="i-x-space-between">
                                <div>{text || "-"}</div>
                                <div className="i-x-right">
                                    {isAllowToManage() && <Button className="table-btn edit" size="small" style={{ marginRight: "10px" }}
                                        onClick={() => {
                                            nameTitleForm.setFieldsValue({
                                                nameTitleId: record.nameTitleId,
                                                nameTitleDesc: record.nameTitleDesc,
                                            });
                                            handleSetState({
                                                formOpen: true,
                                                formType: "Edit",
                                            })
                                        }}
                                    ><EditOutlined /> Edit</Button>
                                    }
                                </div>
                            </div>,
                        },
                    ]}
                />
            </Container>
            <Drawer title={`${state.formType} Name Title`}
                width={window.innerWidth > 500 ? 500 : window.innerWidth - 80}
                open={state.formOpen}
                extra={
                    <Button type="primary"
                        loading={state.btnSubmitLoading}
                        onClick={() => nameTitleForm.submit()}
                        icon={state.formType === "Add" ? <PlusOutlined /> : <SaveOutlined />}
                    >
                        {state.formType === "Add" ? "Add" : "Update"}
                    </Button>
                }
                onClose={() => {
                    nameTitleForm.resetFields()
                    handleSetState({
                        formType: "Add",
                        formOpen: false,
                        btnSubmitResStatus: "",
                        btnSubmitResMsg: "",
                    })
                }}
            >
                <div className="i-y-100 i-y-space-between">
                    <Form
                        form={nameTitleForm}
                        name="name-title-form"
                        layout="vertical"
                        size="middle"
                        requiredMark={false}
                        onFinish={handleOnFinishNameTitle}
                    >
                        {state.btnSubmitResStatus !== ""
                            && <Alert type="error" showIcon style={{ margin: "0px 25px 20px 0px" }}
                                message={state.btnSubmitResMsg}
                            />
                        }
                        <Form.Item hidden={true} name="nameTitleId" ></Form.Item>
                        <Form.Item
                            label="Name Title"
                            name="nameTitleDesc"
                            tooltip="This is a required field"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please enter name title!',
                                },
                            ]}
                        >
                            <Input placeholder='e.g., Mr.' />
                        </Form.Item>
                    </Form>
                    {state.formType === "Edit"
                        ? <div>
                            <Popconfirm
                                title="Delete name title"
                                description="Are you sure to delete this name title?"
                                onConfirm={handleOnDeleteNameTitle}
                                okText="Yes"
                                okType="danger"
                            >
                                <Button type="primary" danger block loading={state.btnDeleteLoading}
                                    icon={<DeleteOutlined />}
                                >Delete Name Title</Button>
                            </Popconfirm>
                        </div>
                        : ""
                    }
                </div>
            </Drawer>
        </Main>
    )
}

export default NameTitle;